import packageJson from 'tv/package.json';
import { CACHE_KEY } from '../../../constants/commonConstants';
import { KEY_CODE } from '../../tving-focusable/contants';
import TvingLogModule from '../../tving-log-module/TvingLogModule';
import { DeviceModelName } from '../types';
var AndroidTvDeviceManager = /** @class */ (function () {
    function AndroidTvDeviceManager() {
        var _this = this;
        this.getMediaInfo = function () {
            _this.logger.info('[AndroidTvDeviceManager.getMediaInfo()]');
            if (_this.NFMedia && Object.prototype.hasOwnProperty.call(_this.NFMedia, 'getInfo')) {
                var response = JSON.parse(_this.NFMedia.getInfo());
                _this.logger.info('[AndroidTvDeviceManager.getMediaInfo()] response', response);
                return response;
            }
            throw new Error('[AndroidTvDeviceManager.getMediaInfo()] NFMedia.getInfo() is undefined');
        };
        this.logger = TvingLogModule;
        this.NFCommon = window.NFCommon;
        this.WFCommon = window.WFCommon;
        this.WFKey = window.WFKey;
        this.NFStorage = window.NFStorage;
        this.NFMedia = window.NFMedia;
        this.WFMedia = window.WFMedia;
        this.TvingPaymentAOS = window.TvingPayment_AOS;
        this.WFPayment = window.WFPayment;
        var deviceInfo = this.NFCommon.getDeviceInfo();
        this.deviceInfo = deviceInfo ? JSON.parse(deviceInfo) : {};
        KEY_CODE.BACK = 300;
        window.WFCommon = window.WFCommon || {};
        window.WFKey = window.WFKey || {};
        window.NFCommon = window.NFCommon || {};
        window.NFStorage = window.NFStorage || {};
        window.NFMedia = window.NFMedia || {};
        window.WFMedia = window.WFMedia || {};
        window.TvingPayment_AOS = window.TvingPayment_AOS || {};
        window.WFPayment = window.WFPayment || {};
        window.WFCommon.login = this.handleLogin.bind(this);
        window.WFCommon.pause = this.handlePause.bind(this);
        window.WFCommon.resume = this.handleResume.bind(this);
        window.WFKey.onEvent = this.handleKeyEvent.bind(this);
        window.WFMedia.onPrepared = this.handlePrepared.bind(this);
        window.WFMedia.onComplete = this.handleComplete.bind(this);
        window.WFMedia.onBufferingUpdate = this.handleBufferingUpdate.bind(this);
        window.WFMedia.onError = this.handleMediaError.bind(this);
        window.WFPayment.purchaseInfo = this.handlePurchaseInfo.bind(this);
        window.WFPayment.purchase = this.handlePurchase.bind(this);
        window.WFPayment.restore = this.handleRestore.bind(this);
    }
    AndroidTvDeviceManager.prototype.init = function () {
        this.logger.info('[AndroidTvDeviceManager.init()]');
        var deviceInfo = this.NFCommon.getDeviceInfo();
        this.deviceInfo = JSON.parse(deviceInfo);
        localStorage.setItem(CACHE_KEY.uuid, this.deviceInfo.result.uuid);
        return Promise.resolve();
    };
    // =================
    // Common interface
    // =================
    AndroidTvDeviceManager.prototype.getDeviceInfo = function () {
        this.logger.info('[AndroidTvDeviceManager.getDeviceInfo()]');
        if (this.deviceInfo) {
            this.logger.info('[AndroidTvDeviceManager.getDeviceInfo()] response', this.deviceInfo);
            var result = this.deviceInfo.result;
            var model = result.model, appVer = result.app_ver, uuid = result.uuid, platformOs = result.os_ver, resolutionWidth = result.resolution_w, resolutionHeight = result.resolution_h;
            var deviceModel = void 0;
            if (model && model.length > 0) {
                deviceModel = model.slice(0, 20);
            }
            else {
                deviceModel = DeviceModelName.android;
            }
            return {
                osVersion: platformOs,
                platformOs: platformOs,
                appVersion: appVer,
                appWebVersion: "".concat(appVer, "_").concat(packageJson.version),
                deviceModel: deviceModel,
                resolutionWidth: parseInt(resolutionWidth, 10),
                resolutionHeight: parseInt(resolutionHeight, 10),
                uuid: uuid,
            };
        }
        throw new Error('[AndroidTvDeviceManager.getDeviceInfo()] NFCommon.getDeviceInfo() is undefined');
    };
    AndroidTvDeviceManager.prototype.login = function (profileToken, userId, userNo, profileNo, userToken, authToken, accessToken, refreshToken) {
        this.logger.info('[AndroidTvDeviceManager.login()] profileToken:', profileToken, ', userId:', userId, ', userNo:', userNo, ', profileNo:', profileNo, ', userToken:', userToken, ', accessToken:', accessToken, ', refreshToken:', refreshToken);
        if (this.NFCommon && Object.prototype.hasOwnProperty.call(this.NFCommon, 'login') && typeof this.NFCommon.login === 'function') {
            var appVersion = this.getDeviceInfo().appVersion;
            var versionThreshold = '5.0.2';
            // 5.0.2 버전 이상인 경우만 authToken 전달
            var isAvailableAuthToken = appVersion >= versionThreshold;
            var response = isAvailableAuthToken
                ? JSON.parse(this.NFCommon.login(profileToken, userId, userNo, profileNo, userToken, authToken))
                : JSON.parse(this.NFCommon.login(profileToken, userId, userNo, profileNo, userToken));
            this.logger.info('[AndroidTvDeviceManager.login()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.login()] NFCommon.login() is undefined');
    };
    AndroidTvDeviceManager.prototype.subscribeInfo = function (isSubscribe) {
        this.logger.info('[AndroidTvDeviceManager.subscribeInfo()] isSubscribe:', isSubscribe);
        if (this.NFCommon && Object.prototype.hasOwnProperty.call(this.NFCommon, 'subscribeInfo') && typeof this.NFCommon.subscribeInfo === 'function') {
            this.NFCommon.subscribeInfo(isSubscribe);
        }
        else {
            this.logger.warn('[AndroidTvDeviceManager.subscribeInfo()] NFCommon.subscribeInfo() is undefined');
        }
    };
    AndroidTvDeviceManager.prototype.handleLogin = function () {
        this.logger.info('[AndroidTvDeviceManager.handleLogin()]');
        try {
            var event = new CustomEvent('onLogin', {
                bubbles: true,
                cancelable: true,
                detail: null,
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handleLogin()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.logout = function () {
        this.logger.info('[AndroidTvDeviceManager.logout()]');
        if (this.NFCommon && Object.prototype.hasOwnProperty.call(this.NFCommon, 'logout')) {
            var response = JSON.parse(this.NFCommon.logout());
            this.logger.info('[AndroidTvDeviceManager.logout()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.logout()] NFCommon.logout() is undefined');
    };
    AndroidTvDeviceManager.prototype.exit = function () {
        this.logger.info('[AndroidTvDeviceManager.exit()]');
        if (this.NFCommon && Object.prototype.hasOwnProperty.call(this.NFCommon, 'destroy')) {
            this.NFCommon.destroy();
        }
        else {
            throw new Error('[AndroidTvDeviceManager.exit()] NFCommon.destroy() is undefined');
        }
    };
    AndroidTvDeviceManager.prototype.changeSize = function (width, height) {
        this.logger.info('[AndroidTvDeviceManager.changeSize()]');
        if (this.NFCommon && Object.prototype.hasOwnProperty.call(this.NFCommon, 'changeSize')) {
            var response = JSON.parse(this.NFCommon.changeSize(width, height));
            this.logger.info('[AndroidTvDeviceManager.changeSize()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.changeSize()] NFCommon.changeSize() is undefined');
    };
    // =================
    // Key interface
    // =================
    AndroidTvDeviceManager.prototype.handleKeyEvent = function (type, command) {
        var browserKeyCode;
        try {
            switch (command) {
                case 'KEYCODE_BACK':
                case 'BACK': // 이전
                    browserKeyCode = 300;
                    break;
                default:
                    browserKeyCode = 300;
                    break;
            }
            if (type === 'DOWN') {
                var event = new KeyboardEvent('keydown', {
                    bubbles: true,
                    cancelable: true,
                });
                Object.defineProperty(event, 'keyCode', {
                    get: function () { return browserKeyCode; },
                });
                document.dispatchEvent(event);
            }
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            this.logger.error('[AndroidTvDeviceManager.handleKeyEvent()] error! type:', type, ', command:', command);
            throw new Error("[AndroidTvDeviceManager.handleKeyEvent()] ".concat(e));
        }
    };
    // =================
    // Storage interface
    // =================
    AndroidTvDeviceManager.prototype.setData = function (key, value) {
        this.logger.info('[AndroidTvDeviceManager.setData()]');
        if (this.NFStorage && Object.prototype.hasOwnProperty.call(this.NFStorage, 'set')) {
            this.NFStorage.set(key, JSON.stringify(value));
        }
        throw new Error('[AndroidTvDeviceManager.setData()] NFStorage.set() is undefined');
    };
    AndroidTvDeviceManager.prototype.getData = function (key) {
        this.logger.info('[AndroidTvDeviceManager.getData()]');
        if (this.NFStorage && Object.prototype.hasOwnProperty.call(this.NFStorage, 'get')) {
            var response = JSON.parse(this.NFStorage.get(key));
            this.logger.info('[AndroidTvDeviceManager.getData()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.getData()] NFStorage.get() is undefined');
    };
    AndroidTvDeviceManager.prototype.removeData = function (key) {
        this.logger.info('[AndroidTvDeviceManager.removeData()]');
        if (this.NFStorage && Object.prototype.hasOwnProperty.call(this.NFStorage, 'remove')) {
            var response = JSON.parse(this.NFStorage.remove(key));
            this.logger.info('[AndroidTvDeviceManager.removeData()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.removeData()] NFStorage.remove() is undefined');
    };
    // =================
    // Media interface
    // =================
    AndroidTvDeviceManager.prototype.play = function (contentCode, coverViewImage, isUhd, isFirstPlay) {
        this.logger.info('[AndroidTvDeviceManager.play()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'play')) {
            var response = JSON.parse(this.NFMedia.play(contentCode, coverViewImage, isUhd, isFirstPlay));
            this.logger.info('[AndroidTvDeviceManager.play()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.play()] NFMedia.play() is undefined');
    };
    AndroidTvDeviceManager.prototype.changeQuality = function (qualityCode) {
        this.logger.info('[AndroidTvDeviceManager.changeQuality()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'play_changeQuality')) {
            var response = JSON.parse(this.NFMedia.play_changeQuality(qualityCode));
            this.logger.info('[AndroidTvDeviceManager.changeQuality()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.changeQuality()] NFMedia.play_changeQuality() is undefined');
    };
    AndroidTvDeviceManager.prototype.preview = function (contentCode, coverViewImage, skipDuration) {
        this.logger.info('[AndroidTvDeviceManager.preview()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'preview_play')) {
            var response = JSON.parse(this.NFMedia.preview_play(contentCode, coverViewImage, skipDuration));
            this.logger.info('[AndroidTvDeviceManager.preview()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.preview()] NFMedia.preview_play() is undefined');
    };
    AndroidTvDeviceManager.prototype.setCoverImage = function (coverViewImage) {
        this.logger.info('[AndroidTvDeviceManager.setCoverImage()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'preview_coverImg')) {
            var response = JSON.parse(this.NFMedia.preview_coverImg(coverViewImage));
            this.logger.info('[AndroidTvDeviceManager.setCoverImage()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.setCoverImage()] NFMedia.preview_coverImg() is undefined');
    };
    AndroidTvDeviceManager.prototype.start = function () {
        this.logger.info('[AndroidTvDeviceManager.start()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'start')) {
            var response = JSON.parse(this.NFMedia.start());
            this.logger.info('[AndroidTvDeviceManager.start()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.start()] NFMedia.start() is undefined');
    };
    AndroidTvDeviceManager.prototype.stop = function () {
        this.logger.info('[AndroidTvDeviceManager.stop()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'stop')) {
            var response = JSON.parse(this.NFMedia.stop());
            this.logger.info('[AndroidTvDeviceManager.stop()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.stop()] NFMedia.stop() is undefined');
    };
    AndroidTvDeviceManager.prototype.handlePrepared = function () {
        this.logger.info('[AndroidTvDeviceManager.handlePrepared()]');
        try {
            var event = new CustomEvent('onPrepared', {
                bubbles: true,
                cancelable: true,
                detail: null,
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handlePrepared()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.handleComplete = function () {
        this.logger.info('[AndroidTvDeviceManager.handleComplete()]');
        try {
            var event = new CustomEvent('onComplete', {
                bubbles: true,
                cancelable: true,
                detail: null,
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handleComplete()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.handleBufferingUpdate = function (percent) {
        this.logger.info('[AndroidTvDeviceManager.handleBufferingUpdate()]');
        try {
            var event = new CustomEvent('onBufferingUpdate', {
                bubbles: true,
                cancelable: true,
                detail: {
                    percent: percent,
                },
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handleBufferingUpdate()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.handleMediaError = function (errorCode) {
        this.logger.info('[AndroidTvDeviceManager.handleMediaError()]');
        try {
            var event = new CustomEvent('onError', {
                bubbles: true,
                cancelable: true,
                detail: {
                    errorCode: errorCode,
                },
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handleMediaError()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.stopAsync = function (callbackFunction) {
        this.logger.info('[AndroidTvDeviceManager.stopAsync()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'stopAsync')) {
            var response = JSON.parse(this.NFMedia.stopAsync(callbackFunction));
            this.logger.info('[AndroidTvDeviceManager.stopAsync()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.stopAsync()] NFMedia.stopAsync() is undefined');
    };
    AndroidTvDeviceManager.prototype.pause = function () {
        this.logger.info('[AndroidTvDeviceManager.pause()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'pause')) {
            var response = JSON.parse(this.NFMedia.pause());
            this.logger.info('[AndroidTvDeviceManager.pause()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.pause()] NFMedia.pause() is undefined');
    };
    AndroidTvDeviceManager.prototype.handlePause = function () {
        this.logger.info('[AndroidTvDeviceManager.handlePause()]');
        try {
            var event = new CustomEvent('onPause', {
                bubbles: true,
                cancelable: true,
                detail: null,
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handlePause()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.handleResume = function () {
        this.logger.info('[AndroidTvDeviceManager.handleResume()]');
        try {
            var event = new CustomEvent('onResume', {
                bubbles: true,
                cancelable: true,
                detail: null,
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handleResume()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.getMediaInfoAsync = function (callbackFunction) {
        this.logger.info('[AndroidTvDeviceManager.getMediaInfoAsync()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'getInfoAsync')) {
            var response = JSON.parse(this.NFMedia.getInfoAsync(callbackFunction));
            this.logger.info('[AndroidTvDeviceManager.getMediaInfoAsync()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.getMediaInfoAsync()] NFMedia.getInfoAsync() is undefined');
    };
    AndroidTvDeviceManager.prototype.seek = function (position) {
        this.logger.info('[AndroidTvDeviceManager.seek()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'seek')) {
            var response = JSON.parse(this.NFMedia.seek(position));
            this.logger.info('[AndroidTvDeviceManager.seek()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.seekTo()] NFMedia.seek() is undefined');
    };
    AndroidTvDeviceManager.prototype.release = function () {
        this.logger.info('[AndroidTvDeviceManager.release()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'release')) {
            var response = JSON.parse(this.NFMedia.release());
            this.logger.info('[AndroidTvDeviceManager.release()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.release()] NFMedia.release() is undefined');
    };
    AndroidTvDeviceManager.prototype.showSubtitle = function (subtitleCode, size) {
        this.logger.info('[AndroidTvDeviceManager.showSubtitle()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'show_subtitle')) {
            var response = JSON.parse(this.NFMedia.show_subtitle(subtitleCode, size));
            this.logger.info('[AndroidTvDeviceManager.showSubtitle()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.showSubtitle()] NFMedia.show_subtitle() is undefined');
    };
    AndroidTvDeviceManager.prototype.getSubtitleSize = function () {
        this.logger.info('[AndroidTvDeviceManager.getSubtitleSize()]');
        if (this.NFMedia && Object.prototype.hasOwnProperty.call(this.NFMedia, 'get_subtitleSize')) {
            var response = JSON.parse(this.NFMedia.get_subtitleSize());
            this.logger.info('[AndroidTvDeviceManager.getSubtitleSize()] response', response);
            return response;
        }
        throw new Error('[AndroidTvDeviceManager.getSubtitleSize()] NFMedia.get_subtitleSize() is undefined');
    };
    // =================
    // Payment interface
    // =================
    AndroidTvDeviceManager.prototype.requestPurchaseInfo = function () {
        this.logger.info('[AndroidTvDeviceManager.requestPurchaseInfo()]');
        if (this.TvingPaymentAOS && Object.prototype.hasOwnProperty.call(this.TvingPaymentAOS, 'requestPurchaseInfo')) {
            this.TvingPaymentAOS.requestPurchaseInfo('WFPayment.purchaseInfo');
        }
        else {
            throw new Error('[AndroidTvDeviceManager.requestPurchaseInfo()] TvingPayment_AOS.requestPurchaseInfo() is undefined');
        }
    };
    AndroidTvDeviceManager.prototype.handlePurchaseInfo = function (purchaseInfoResponse) {
        var _a;
        this.logger.info('[AndroidTvDeviceManager.handlePurchaseInfo()]: ', purchaseInfoResponse);
        try {
            var response = purchaseInfoResponse ? JSON.parse(purchaseInfoResponse) : undefined;
            var event = new CustomEvent('onPurchaseInfo', {
                bubbles: true,
                cancelable: true,
                detail: {
                    result: ((_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.length) > 0 ? response.response[0] : undefined,
                },
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handlePurchaseInfo()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.requestPurchase = function (productId, oldPurchaseToken, updateFlag) {
        this.logger.info('[AndroidTvDeviceManager.requestPurchase()]', productId, oldPurchaseToken, updateFlag);
        if (this.TvingPaymentAOS && Object.prototype.hasOwnProperty.call(this.TvingPaymentAOS, 'requestPurchase')) {
            this.TvingPaymentAOS.requestPurchase(productId, oldPurchaseToken, updateFlag, 'WFPayment.purchase');
        }
        else {
            throw new Error('[AndroidTvDeviceManager.requestPurchase()] TvingPayment_AOS.requestPurchase() is undefined');
        }
    };
    AndroidTvDeviceManager.prototype.handlePurchase = function (purchaseResultCode, purchaseResponse) {
        this.logger.info('[AndroidTvDeviceManager.handlePurchase()]', purchaseResultCode, purchaseResponse);
        try {
            var event = new CustomEvent('onPurchase', {
                bubbles: true,
                cancelable: true,
                detail: {
                    purchaseResultCode: purchaseResultCode,
                },
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handlePurchase()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.requestRestore = function () {
        this.logger.info('[AndroidTvDeviceManager.requestRestore()]');
        if (this.TvingPaymentAOS && Object.prototype.hasOwnProperty.call(this.TvingPaymentAOS, 'requestRestore')) {
            this.TvingPaymentAOS.requestRestore('WFPayment.restore');
        }
        else {
            throw new Error('[AndroidTvDeviceManager.requestRestore()] TvingPayment_AOS.requestRestore() is undefined');
        }
    };
    AndroidTvDeviceManager.prototype.handleRestore = function (restoreResultCode, restoreResponse) {
        var _a, _b;
        this.logger.info('[AndroidTvDeviceManager.handleRestore()]', restoreResultCode, restoreResponse);
        try {
            var resObj = restoreResponse ? JSON.parse(restoreResponse) : undefined;
            var resCode = '-1'; // 기본 실패
            if (restoreResultCode === '0') {
                switch ((_b = (_a = resObj === null || resObj === void 0 ? void 0 : resObj.body) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.code) {
                    case 1: // 성공
                        resCode = '0';
                        break;
                    case 2: // 복원할 이력 없음
                    case 3: // 타계정에 지급된 이용권
                        resCode = '-2';
                        break;
                    case -1: // 복원 실패
                    default:
                        resCode = '-1';
                }
            }
            var event = new CustomEvent('onRestore', {
                bubbles: true,
                cancelable: true,
                detail: {
                    code: resCode,
                },
            });
            document.dispatchEvent(event);
            return {
                code: '00',
                message: '성공',
            };
        }
        catch (e) {
            throw new Error("[AndroidTvDeviceManager.handleRestore()] ".concat(e));
        }
    };
    AndroidTvDeviceManager.prototype.deeplink = function () {
        this.logger.info('[AndroidTvDeviceManager.deeplink()]');
    };
    AndroidTvDeviceManager.prototype.twoDepth = function (data) {
        this.logger.info('[AndroidTvDeviceManager.twoDepth()]', data);
    };
    return AndroidTvDeviceManager;
}());
export default AndroidTvDeviceManager;
